import {
  Box,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
  Text,
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { COMMON_WEB_PATH } from "../../constant";
import { useTranslation } from "react-i18next";
import { isValidMotionProp, motion } from "framer-motion";
import { IoMdClose } from "react-icons/io";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const TermsModal = ({ onClose, tabIndex: initialTabIndex = 0 }) => {
  const { t } = useTranslation();
  const i18nTerms = (key) => t(`Terms And Service.${key}`);
  const i18nPrivacy = (key) => t(`Privacy Policy.${key}`);
  const i18n = (key) => t(`Terms And Service.${key}`);
  const [tabIndex, setTabIndex] = useState(initialTabIndex);

  // 當 initialTabIndex 變更時，更新 tabIndex
  useEffect(() => {
    setTabIndex(initialTabIndex);
  }, [initialTabIndex]);

  // 處理標籤切換
  const handleTabsChange = (index) => {
    setTabIndex(index);
  };

  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="rgba(0, 0, 0, 0.8)"
      zIndex="10000" // 要比AgeCheckModal的z-index大
      backdropFilter="blur(2px)"
      justifyContent="center"
      alignItems="center"
    >
      <ChakraBox
        as={Flex}
        w={{ base: "95%", md: "600px" }}
        maxH="80vh"
        bgImage={`url('${COMMON_WEB_PATH}/911TW/langBG.webp')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        p={6}
        px={{ base: 4, md: 8 }}
        paddingTop={{ base: "50px", sm: "50px", lg: "50px" }}
        // 動畫效果
        initial={{
          opacity: 0,
          scale: 0.9,
        }}
        animate={{
          opacity: 1,
          scale: 1,
        }}
        transition={{ duration: 0.3 }}
        position="relative"
      >
        <Button
          position="absolute"
          top="10px"
          right="20px"
          bg="transparent"
          color="white"
          _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
          onClick={onClose}
        >
          <IoMdClose size={24} />
        </Button>

        {/* <Box
          fontSize={{ base: "22px", lg: "26px", xl: "28px" }}
          color="white"
          textAlign="center"
          mb={4}
        >
          <Text color="#FFF" fontWeight="700">
            {tabIndex === 0
              ? i18n("Terms And Service")
              : i18n("Privacy Policy")}
          </Text>
        </Box> */}

        <Tabs
          colorScheme="purple"
          variant="enclosed"
          index={tabIndex}
          onChange={handleTabsChange}
          w="100%"
        >
          <TabList mb="1em">
            <Tab
              color="white"
              _selected={{
                color: "#e8c3ff",
                borderColor: "#e8c3ff",
                borderBottomColor: "transparent",
              }}
              _hover={{ color: "#e8c3ff" }}
              flex="1"
              fontWeight="600"
            >
              {i18nTerms("Terms of Service")}
            </Tab>
            <Tab
              color="white"
              _selected={{
                color: "#e8c3ff",
                borderColor: "#e8c3ff",
                borderBottomColor: "transparent",
              }}
              _hover={{ color: "#e8c3ff" }}
              flex="1"
              fontWeight="600"
            >
              {i18nPrivacy("Privacy Policy")}
            </Tab>
          </TabList>

          <TabPanels>
            {/* 服務條款內容 */}
            <TabPanel p={0}>
              <Box
                overflowY="auto"
                h="350px"
                w="100%"
                pr={2}
                css={{
                  // Firefox滾動條樣式
                  scrollbarWidth: "auto",
                  scrollbarColor: "#fdd26a rgba(0,0,0,0.3)",
                }}
                sx={{
                  ".chakra-menu__menuitem": {
                    paddingLeft: "15px",
                    paddingRight: "15px",
                  },
                  "&::-webkit-scrollbar": {
                    width: "15px",
                    display: "block",
                  },
                  "&::-webkit-scrollbar-track": {
                    bg: "rgba(0,0,0,0.3)",
                    borderRadius: "10px",
                    margin: "5px 0",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    bg: "linear-gradient(180deg, #fdd26a 0%, #b07f20 100%)",
                    borderRadius: "10px",
                    border: "3px solid rgba(0,0,0,0.2)",
                    boxShadow: "inset 0 0 5px rgba(255,255,255,0.3)", // 內光暈
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    bg: "linear-gradient(180deg, #ffdf8a 0%, #d19c2a 100%)",
                  },
                }}
              >
                <Text color="#e8c3ff" mb={4} fontSize="18px" fontWeight="600">
                  {i18n("Terms of Service")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    'Please read the following rules and terms ("Terms") carefully. By registering for an account ("User Account" or "Account"), the User accepts the Terms by default.'
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    'These Terms apply to all of 911win\'s products and services ("Services"), website ("Site") and any transactions related to the Services ("Bets"). These terms and conditions, rules and regulations, and privacy policy are written in traditional Chinese. If these terms and conditions, rules and regulations, and privacy policy are translated in any language other than Traditional Chinese, the Traditional Chinese version will be the final interpretation.'
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("1 Introduction to Rules and Terms")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("1.1 The company")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("2 Partners")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    '2.1 Both parties must abide by the following rules and terms ("the company", or "company" in the terms).'
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("3 Scope and conditions of the terms")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "3.1 As long as the user logs in to the website to use the company's services, and/or opens an account with the company, and/or bets in the company, the company will be deemed to have read, understood and accepted these terms and conditions. After agreeing These Terms and Conditions and/or by virtue of the User's continued use of the Site, the User is bound by the Terms and Conditions which are governed by the Company's Bylaws and Privacy Policy. If any of these Terms and Conditions and the incorporated reference In the event of any inconsistencies, these terms and conditions shall be the final reference at all times."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "3.2 These Terms will take effect on July 1, 2017. From time to time, we may need to make changes to the Terms for a number of reasons. Reasons include (but are not limited to) business reasons, to comply with laws or regulations, to follow guidance or advice from regulatory authorities for customer service reasons. You can review the most current version of the Terms by clicking on the Terms of Use link in the footer section of the website. The date of entry into force will be indicated at the beginning of 3.2."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "3.3 If the terms need to be changed, the company will notify users in advance as soon as possible. The method is as follows: For minor and unimportant changes, the company will not notify, and it is better for users to read the rules and terms regularly. Continued use of the Site and Services after the terms have been changed will be deemed to be in effect at the default terms."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "3.4 The company will use prudent and reasonable methods to notify the user of the terms of the change that needs to be reminded, including: email address (to the email address provided by the user); account on the user website; notice on the website, that is, click Yes or I Accept in the checkbox of the new terms. As long as the User acknowledges the notice, or continues to use the Site or Services after the notice, the User will presume to accept and be bound by the Terms, including (for the avoidance of doubt) whether or not the User has read the changed Terms. If the user does not accept the changed terms, the user may stop using the service or close the user's account."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "3.5 According to the changes in the terms of the held funds mentioned in clause 3 and clause 7, the company will notify the user in advance in a prudent and reasonable manner, and the user needs to click Yes or I accept in the checkbox of the new terms to confirm the changes. As long as the user confirms the notification, the user will accept the terms and be bound by the terms by default. If the user does not accept the changed terms, the user can stop using the service or close the user's account."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("4 Account opening and maintenance")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "4.1 If the user wants to bet online, the user needs to register and hold the user's account."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "4.2 The user agrees to provide all relevant personal data regarding the registered company, it is the user's responsibility to ensure that the user's personal information is kept up-to-date on the website, in particular addresses, telephone numbers and Payment/banking details (if applicable). The user must truthfully provide that when the account is opened, there has been no violation of these terms and conditions that would result in the forfeiture of all available funds in the account. The user agrees to provide any file to the company to verify the authenticity of the personal information provided by the user. The user authorizes the company to use whatever the company deems necessary to verify the personal information provided by the user in the form of online registration (legal means \"personal information\")). These personal data include all information required from the user, at the Company's absolute discretion, to enable the Company to correctly identify the User. When the above registration form on this website has been submitted and accepted by the Company, the user will be deemed a registered customer (\"registered customer\"). The company reserves the right to accept or reject registration for any reason. Only registered users can use the company's services and their betting amount cannot exceed the maximum limit set by them, and the betting amount cannot exceed the total amount of their account."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("4.3 To")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("4.3.1 If")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "1. Use of this website is prohibited within the jurisdiction of the user's country or for any reason."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "2. Gambling is prohibited within the jurisdiction of the country where the user is located."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "3. If the area where the user lives prohibits its residents from participating in online gambling, at the same time"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    '4. If the user resides in any of the following countries or jurisdictions: Hong Kong Special Administrative Region, Macao Special Administrative Region, the United States and its territories, Israel, the United Kingdom, France, Spain, Portugal, Switzerland, Ireland, Belgium, Cyprus, Turkey, Taiwan, Singapore, Republic of the Philippines (collectively, the "Prohibited Jurisdictions").'
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "The countries or jurisdictions in which the site or services may be used do not include countries or jurisdictions where the Company offers, invites or solicits the use of the site but itself prohibits gambling. The user agrees that use of this website is at the user's own risk and further understands and agrees that the user may lose money as a result of wagering outside of the use of the website and/or the services provided, and the user accepts full responsibility for any such loss."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    '4.3.3(a) The User is at least 18 years of age, or (b) in a jurisdiction where sports betting is legal in the User\'s area, whichever is higher ("Relevant Age").'
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "4.3.4 User is not prohibited from participating in gaming activities."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "4.3.5 the user is able to enter into legally binding contracts, including these rules and terms and any terms of the user's use of the company's services."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("4.3.6 The user has never had a closed account.")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "4.4 Users are only allowed to open one account on this website. The company reserves the sole and absolute discretion to verify any user who opens multiple accounts. The company will close its duplicate account or push the balance of its duplicate account to Return users, or merge them. Users need to agree that the company will deal with duplicate registered accounts in a way it considers reasonable."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "4.5 In order to maintain a high level of security to protect client funds, the company may perform arbitrary security checks. The user hereby agrees that the company has the right to request the user to provide additional information and/or from the user's file to verify the user's identity as the account holder."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "4.6 Users should check the account balance each time they log in to the website. In case of any problem with the user's account balance, the user should immediately notify the company, and provide the company's last verification date of the user's account balance and the user's transaction records. If the company has no record of any balance in the user's account within 7 days of the above date, the user agrees to waive any recourse for any discrepancy in the user's account and accepts all information on the user's account."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "5 Identity Verification/Anti-Money Laundering Requirements"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("5.1 User Guarantee")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("5.1.1 Account")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "5.1.2 User is the legal owner of funds deposited into the account."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    '5.2 After agreeing to the above terms, the user authorizes the company to conduct identity verification from time to time, which is the requirement of the company and third-party vendors (including but not limited to regulatory authorities) to verify information (the "verification"). Therefore, the user must from time to time provide more details of the information provided, including account deposit information.'
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "5.3 When the company conducts information verification, it will limit the user's withdrawal request and use of the website and other services. Due to regulatory, security and other business reasons, the company will perform double verification of information. If users have any questions, please contact the Support team."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "5.4 In some cases, the company may contact the user and ask for more detailed information so that the company can complete the verification. To this end, the company will exercise the absolute and sole right to require users to provide notarized identity documents or any legally valid identification, and other address proofs, utility bills, bank information, bank statements and bank credit certificates. Until the information provided by the user meets the verification requirements, the company will prevent or authorize the user to carry out any account-related activities. If the company confirms that the information provided by the user is untrue, the company will have the right to confiscate the user's account money and close the relevant account."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("5.5 Users")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("5.5.1 User")}{" "}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "5.5.2 All transactions will be invalidated and related deposit funds will be refunded according to the payment method of the funds deposit (if applicable);"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "5.5.3 Deposits under legal age will be refunded in full."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "5.5.4 Winnings under legal age will be forfeited (or deducted from deposits refunded in 5.5.3 ) and the user must return the funds withdrawn from the account."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("6 Username, Password, PIN, and Customer Information")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "6.1 As a registered customer, the user will use a username and password ('Account Inquiry Information'), this account is limited to the personal use of the user, and the user shall be responsible for ensuring the confidentiality of the account access information at any time. User shall be fully responsible for any misuse and/or disclosure of unauthorized access account information to any third party. If the user is worried that the user's account query information has been released to the public, its security is violated or accessed by any third party, the user should immediately notify the company, and the company will immediately query the account information. Only after the user notifies the user that the account access signal has been compromised, and the company will suspend the account betting or request the company to make bets and the online account of the request is deemed invalid."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "6.2 The company may require the user to change the user's password or query the user's account information, otherwise the company may suspend the user's account, if the company has reason to believe that there may be abuse of the secure website. The Company reserves the right, at its sole and absolute discretion, to amend account inquiry information prior to notifying the User."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "6.3 If you lose your account password for any reason, you can apply to our customer service staff to get it back. You must provide correct registration information, including your account number and phone number, etc., when requesting your password back. If the information is incorrect and cannot be verified, all rights will be forfeited."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("7 Account Funding")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "7.1 Users can only make deposits to the Company through the pre-approved payment methods published on this website, the User must only use the same payment solution, provided by the Company Authorized Company ('Authorized Payment Funding Solutions') Deposits and collections, unless the User's money is deposited directly with the Company. Authorized Payment Solutions, Inc. The Company funds and further authorizes Payment Solutions not to market, advertise, promote, or promote the Company or the Company's services in any way without the Company's prior written statement. For details of deposit and withdrawal and deposit limits, users can refer to the payment method page of the website."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "7.2 If the user is not the account holder in the payment method, all deposits made by the user will be considered void (and all bonuses will be voided) after all verifications in clause 5.2 have been completed."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "7.3 All bets must be supported by sufficient funds, and the company reserves the right to void bets that do not have sufficient funds."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "7.4 If the user refuses to pay, withdraw funds or make other payments, the company has the right to collect relevant payments from the user. For the avoidance of doubt, the user's account cannot be used as a bank account and the company accordingly cannot deposit or withdraw money from the account for wagering, but the company reserves the right to deduct administrative costs therefrom (regardless of closing or suspending the account). Deposit funds do not charge interest."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "7.5 Due to the transaction costs of third parties, the company has the right to charge appropriate deposit and withdrawal fees according to the selected payment method. The company will notify you of the relevant situation."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "7.6 It is the user's responsibility to inform him or her of any winnings or losses received, upon request by the user's local or tax or other authorities."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "7.7 All winnings wagered will be deposited into the user's account. In the event of an error in the deposit process, the User shall immediately inform the Company. Bets placed using the miss bonus will be considered void and account adjustments will restore such funds."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "7.8 Users need to keep actively using the company's account. Users must log in and use the Site at least once in any 12-month period to maintain an active account. If the user's account is inactive for 12 consecutive months or more, the company reserves the right to close the account, and the user also agrees to forfeit the account balance and hold the company accountable."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "7.9 The company will review the customer database annually to see if there are 'inactive' accounts that have not been consigned. If the account is designated as an inactive account, the company will contact the user by phone, mail or letter according to the information provided by the user. If the user is still unable to be contacted within 12 months after the account is designated as 'inactive,' the outstanding funds will be rejected, the account will be closed, and the funds will be distributed to the charity designated by the company."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("8. BET ACCEPTANCE AND SERVICE USE")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.1 The Company only accepts bets from registered users via the website. For betting and the use of services, please refer to the description under the description option. Betting details, bets placed using the Site and similar transactions ('Transactions') are subject to strict compliance with the relevant betting rules and game rules."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.2 Registered users can only place bets through this website, and the user's bets are considered to be recorded from the Internet Protocol address in their jurisdiction. A bet will only be accepted if the company's server receives and confirms the bet. When a user has successfully placed a bet on the site, the user will receive an electronic confirmation (advice), which is a record of the company's acceptance and confirmation of the bet. When a bet has been accepted and successfully recorded, the site will notify the user of this information. A bet will only be considered successful when it is received and recorded by the Company's servers in that jurisdiction, provided that the bet complies with the above terms and conditions."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.3 A bet will be considered void if the transmission of the bet is not completed, including but not limited to where the transmission is disrupted or interrupted due to technical problems."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.4 Users are not allowed to cancel or change bets that have been confirmed, accepted and recorded by the company. If the user has any disputes when betting, please notify the company before the bet is confirmed. The Company reserves the sole and reasonable discretion to investigate such bets."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.5 The Company reserves the right to suspend or prohibit further betting at any time. When a wagering event is suspended or access is disabled, any attempt to enter wagering will be denied."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.6 If the company has solid evidence that the continued use of the account will cause any form of harm or loss to the user or the company; or is in violation of the terms, rules or regulations, or the privacy policy; or the company confirms that the user has violated these terms or the user File a complaint. The Company reserves the right, in its sole and absolute discretion, to reject any bet or any unstated partial bet; or to suspend or close an account at any time for any reason."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.7 The company does not assume any responsibility for the confirmation, acceptance or recording of bets caused by equipment or telecommunications."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.8 The company shall not be liable for losses caused by the lack of content on the website, including but not limited to delays in operation or transmission interruptions, communication line failures, and losses caused by any errors or omissions by anyone using the website."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.9 Bets will be accepted after the acceptance period has expired. Betting deadlines are subject to the terms and conditions and users must abide by them. If a bet is accepted after the betting deadline, the company reserves the right to treat the bet as void."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.10 Bets placed by credit or debit card will not be considered live until full payment has been received by the Company until the Company (or its authorized payment solution) has received valid full payment pursuant to paragraph 8.2 . Bets will automatically be void until all bets have been paid off by the user."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.11 The user's account must have a sufficient funds balance to cover the amount the user is able to wager on. Otherwise betting will not be allowed."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.12 All odds displayed on the website will be subject to change, but when the bet is confirmed, the odds corresponding to the bet will be locked and subject to Article 8.2 of the above terms and conditions. The company reserves the right to change odds, prices and any betting information at any time without prior notice. Likewise the Company reserves the right, at its sole discretion, to correct any errors, omissions or the possibility of incorrectness arising from any effect at any time. Should this occur, the Company will place a prominent notice on the website."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "8.13 Different market betting types are accompanied by the highest betting amount, and the company reserves the sole and absolute discretion to modify it without notifying the user."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("9 Collusion, Cheating, Fraud and Criminal Conduct")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "9.1 The following conduct matters (any one) related to the website: Misuse of bonuses and other preferential funds Use of unfair external factors and Influence (referred to as cheating) Obtaining unfair benefits (Article 9.5.3); Opening duplicate accounts Engaging in fraudulent and criminal acts (Article 9.5), all of the above are 'prohibited items', and users must strictly abide by them, otherwise they will be regarded as violations terms. The company will do its best to monitor and curb the above-mentioned rules, and once the user violates the terms, the company will immediately find out the relevant violators. The company will not be responsible for any losses caused thereby, and has the right of final judgment."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "9.2 Once the user finds any player who violates the prohibited items, he should immediately report to the customer service team through the website."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "9.3 Users are prohibited from participating in any behavior related to prohibited matters during the use of the website and services."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("9.4 If")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("9.5 For")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("9.5.1")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("9.5.2")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("9.5.3 'Unfair")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("9.6 The company")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("9.7 The company")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "10 Closing Accounts: Termination Rules and Terms User Closing Account Termination Agreement"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "10.1 Users may entrust sales from their account, provided that the user's account has sufficient balance and the consignment has been Through the company's approval, users need to refer to the entrustment instructions provided by the website before entrusting the sale."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "10. 2 Users can cancel their account, please contact us. If the user decides to cancel the company's account, the user must immediately stop using this website. Only after the company confirms that the account has been canceled, the bets or requests made are deemed invalid, and the user will continue to be responsible for any activities of the user's account until the cancellation of the account is notified to the company from the above."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "10.3 Upon closure of an account under Clause 10, the Company reserves the right (not limited by its power under Clause 10.5) to forfeit funds for violations of: (a) Pursuant to Clause 9 (collusion, cheating, fraud and criminal conduct); (b) Pursuant to Clause 17 (violation of rules and terms); (c) other terms (including such as 5.4); (d) laws and regulations."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "10.4 When repaying the outstanding balance, the company will use the payment method when the user registered the account, or other reasonable payment methods. The company closes the account and terminates the agreement."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "10.5 The company has the absolute sole discretion to close the account and terminate the agreement (notwithstanding other terms and conditions that contain this rule and clause) by written notice (or specific notice) to the user based on the contact information. Pursuant to Clause 10, before the termination of the agreement, the company will refund the user's remaining payment as soon as possible."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "10.6 Regarding clause 9 (collusion, cheating, fraud and criminal conduct) or clause 17 (violation of rules and regulations), after the company closes the user's account and terminates the agreement, the balance of the user's account will not be refunded and will be confiscated by the company. Closure of the account and suspension of the terms will not affect the unplaced bets provided that the unplaced bets do not breach any of the terms, except clauses 9 and 17. For the avoidance of doubt, upon account closure (whether at the User's request or the Terms), the Company will no longer issue any bonuses and the User will not be entitled to receive any possible bonuses. Suspension of Accounts"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "10.7 The Company reserves the right in its absolute sole discretion to suspend User Accounts as described in the Terms. After the account is suspended: (a) any account activity (including deposits, withdrawals, wagering or gaming) is prohibited until the account is reactivated; (b) bonuses and bonuses will no longer be issued to the user's account; (c) after the account is suspended, the company Resulting issues will be addressed as soon as possible so that accounts can be reactivated or closed. 11 Third Party Suppliers"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "11.1 The Company accepts information and services from third party suppliers including sports, poker and casino. Through the system provided by the third-party supplier, the user sometimes cannot view the account history and transaction information controlled by the company. If the user wants to know the relevant information, please contact the company's customer service."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "11.2 If the company wants to use the company's services, it must download and install the software provided by the third party in the access device ('software'). The software includes, but is not limited to: access to device applications and any other promotional or marketing applications, services and services, subject to an agreement between the user and the owner or licensor in the software of the third party ('Third Party Software Agreement') . In the event of a conflict between the Terms and the Third Party Software Agreement, the Company Terms will control."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "11.3 The company does not allow any employee or anyone to get in touch with software employees or any employees of the service provider (determined by the company at its absolute discretion) in any way, so as to be in the market or event where the provider provides the service Bet on. Otherwise, all bets related to it will be deemed invalid, and the company has the absolute sole right to decide."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "11.4 The user acknowledges that the company's server random number generator will determine the results of the game, and the user accepts all game results. User also acknowledges that if there is any discrepancy between the results on the screen and the company's game server results, the game server results will prevail, and the user acknowledges that the company's records are the final authoritative source for the terms and conditions of the relevant online gaming activity and results."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "11.5 Third-party links are provided for user convenience only. If a user visits a third-party link, the user will leave the main page and accept the terms of use of a different site. Other websites operated by the company provide information that is not suitable for anyone, and users who click on such websites must read and accept the relevant terms of use."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("12 IT failure/mistakes")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.1 If there is any problem with the software and hardware provided by the company, the company will take all reasonable measures to solve the problem as soon as possible. If the problem causes the game to be interrupted, and it cannot be completely restored to the original game without damage, the company will take all measures to give the user a fair answer (including restoring the balance of the user account to the time of the last bet or the last game login before the problem occurred)."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("12.2 In")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.2.1 Due to obvious errors or negligence in information input, handicap setting or computer failure, the company falsely reports odds or Betting terms or gaming bets."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("12.2.2 Company")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.2.3 The betting market before the start of the game is obviously different from the general market."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.2.4 When the game starts, the betting market provided is obviously incorrect."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("12.2.5 The company")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.2.6 Negligence due to the prohibitions of clause 9.1"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("12.2.7 The company")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.2.8 Due to manual or computer errors, the company made mistakes in the amount of bonuses and refunds."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("12.2.9 The company")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.3 For mistakes, the company reserves the right to:"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.3.1 Correct the wrong bet and reset the correct odds that were or should have been used (except for published mistakes) at the time the bet was made, and the bet has been placed at the current odds by default."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.3.2 If the odds cannot be corrected and reset under the clause 12.3.1, the bet will be declared invalid and the betting amount of the user will be returned."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("12.3.3 Due to")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.4 Funds released to the account, funds paid to the user by mistake, funds held up in clause 12.3 or funds owed by the company to the user shall be returned to the company immediately when the company demands payment. If the above situation occurs and the user's account has sufficient funds, the company has the right to deduct the funds from the funds. The company will endeavor to identify any errors and notify the user as soon as possible after they have been corrected."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.5 The company (as well as employees and agents) as well as partners and suppliers are not liable for any damages, including loss of prize money due to company errors or user errors."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.6 Once the user becomes aware of any mistakes, he should notify the company immediately."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "12.7 The company reserves the right to confiscate any funds that have been released to the user's account and have been used or have been released to the user due to a betting error; The payment shall be regarded as credit, and the company shall have the right to deduct the payment when the user's account is sufficient, or the user shall repay the payment immediately upon request of the company."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("13 Force Majeure Events")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "13.1 Without affecting the laws and regulations of various jurisdictions, for any loss or damage caused by force majeure events, including (but not limited to) power Faults; trade or labor disputes; errors or omissions of any government or authoritative organization; failure and failure of telecommunication services; or delays or failures caused by any third party and force majeure factors, the company has the right to cancel or suspend the service without any responsibility."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "13.2 Any device or software, no matter where it is or where it is used, regardless of whether it is directly controlled by the company and how it causes the failure, the company will not have any failures that affect the use of the service and contact the company. Responsible."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "13.3 The company shall not be responsible for the losses caused by the third party's failure to perform the contract."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("14 Viruses, hackers and other attacks")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "14.1 Users shall not attack, intrude, change or introduce any malicious code into the website and services without authorization, including but not limited to:"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "14.1.1 Reverse engineer or decompile (in whole or in part) any software on the Internet."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "14.1.2 copy, modify, reproduce, transmit, alter, use or disseminate all or any part of the Service or Site or the Service or Site containing any material or information."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "14.1.3 Disclosing any account information to a third party; or violating any of the above provisions."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "14.1.4 Cheating, deceiving, defrauding, misrepresenting or any other way of defrauding."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "14.1.5 Attack the website by denial of service attack or spreading denial of service attack. The company will report any suspected violation of the Computer Misuse Act 1990 to the relevant law enforcement agencies, and the company will cooperate with the authorities to reveal the identity of the user. In the event of violation of the relevant terms, the company will immediately suspend the user's use of the website and/or service."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "14.2 If the company suspects that the user has not complied with the provisions of this article, the company reserves the right (in addition to any other remedies) to freeze or suspend the user's account and conduct further investigation. If the company confirms that the user fails to comply with the provisions of this article, the company will terminate the service to the user, close the account and confiscate the account balance."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("15 Claims and Disputes")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "15.1 If the User is found to have engaged in fraudulent, dishonest or criminal conduct, the Company will seek criminal and contractual sanctions and deny payment to the User. All costs, expenses or losses (including any direct, indirect or subsidiary losses, loss of profits and loss of reputation) caused by direct or indirect fraudulent, dishonest or criminal acts, the user shall be required and responsible for compensation."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "15.2 If the company has evidence that the following events have occurred, the company has the right to refuse payment and declare that the bet is invalid: (i) The integrity of the event has been questioned (ii) The odds or prize pool has been manipulated (iii) Illegal manipulate. The company may derive evidence by the size, amount or pattern of bets made in any or all of the betting channels. The decision of the relevant governing body, licensing body and/or any relevant industry association (if any) will be final."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "15.3 Once a bet has been placed, accepted and recorded, the user will not be allowed to cancel or change the bet and the Company is under no obligation to cancel a valid, accepted and recorded bet subject to the Rules and Conditions. In case of any dispute over a bet, the User shall inform the Company of the bets placed before the bet is accepted and/or before the event takes place. Company shall have the sole absolute and reasonable discretion to investigate and reasonably resolve such disputes."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("16 Complaints")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "16.1 If the user has any complaints about the company, please contact the company's customer service, and the customer service team will reply to the user as soon as possible."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "16.2 If the user is not satisfied with the decision of the customer service, the user can escalate the complaint. To escalate a complaint, the user needs to clearly state the reasons for dissatisfaction with the previous decision and provide any other relevant information. The decision of the customer service supervisor (if the company deems it reasonable to escalate) will be considered final."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "16.3 If the company needs to contact users, it has the sole and absolute discretion to use any user's contact information. Notifications will be deemed properly delivered three days after the email has been sent or after the Company has communicated directly with the user by telephone (including leaving a message), or after three days after posting a letter. Proof of notification of any service, and conclusive proof must be made, for example, letters must be clearly addressed, stamped, and dropped into the mailbox; emails must be sent to the designated user's email address (if available)."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("17 Violations of the Rules and Conditions")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "17.1 The Company may suspend or cancel the User's account at any time if the User violates any of the Rules and Terms, Regulations, and Privacy Policy. If the user does violate the rules and terms, the company has the sole and absolute discretion to maintain the company's rights and require the user to make compensation. In addition, the Company reserves the right to retain any outstanding funds as security for user obligations and/or for any liability arising from a breach of these terms."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("18 User's Personal Information")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "18.1 User's account information will be stored securely and with the utmost confidentiality, except as otherwise provided in the Terms and Conditions (including, for the avoidance of doubt, the Privacy Policy). It is necessary for the Company to collect User-specific information, including the User's name, date of birth, contact information, and User's marketing preferences (all of which shall be referred to as 'Personal Information') when or before the User uses the Services."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "18.2 The Company may ask the User to provide additional details at any time, and any additional information will be kept confidential."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "18.3 At the request of laws, government departments, or regulatory agencies, the company has the right to submit relevant details to those departments (such as agencies or governments investigating money laundering, fraud, and other criminal activity)."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("19 Use of Website Cookies")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "19.1 Customers should be informed that personal information and data will be automatically collected and stored by cookies during the registration process. Information on deleting or controlling cookies can be found in the Privacy Policy."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("20 NO WARRANTY")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "20.1 The Company is committed to providing users with reasonable skill and care. COMPANY MAKES NO WARRANTIES OR REPRESENTATIONS REGARDING THE SERVICE, EITHER EXPRESS OR IMPLIED. All implied warranties or conditions of satisfaction, fitness for purpose, completeness, or accuracy are hereby excluded."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "20.2 The company does not guarantee the following: the service will meet the user's needs or will be completely uninterrupted, timely, safe, and correct, and the defect will be corrected; or the available website or server will be free of viruses or bugs; accurate and reliable; or the results or any information provided by the website are accurate."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "20.3 The company is not responsible for any system or communication errors related to random number generation, betting, game results, or other service factors and reserves the right to void bets on all relevant events (if applicable)."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("21 Limitation of Liability")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "21.1 Winnings will be credited to the user's account or losses of the account will be reflected in the user's account after the relevant betting result is finalized (in the case of sporting events, subject to the final outcome of the sport’s governing body)."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "21.2 In the event of an error in depositing or debiting funds from the User's account, it is the User's responsibility to notify the Company immediately. Payments due to user error will be deemed void and must be returned to the Company. Users may not place bets or bets with monies resulting from crediting errors, and the Company reserves the right to void such bets. User hereby agrees to return winnings credited to User's account due to any error will be withdrawn."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "21.3 The company will not be responsible for any odds errors caused by typographical, technical, or human errors. In the event of an error, the company reserves the right to void bets placed at these incorrect odds."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "21.4 In no event shall the Company be liable for any damages of any nature, direct, indirect, or of any other nature, whether in contract, tort, negligence, or otherwise (or any legal theory, without limitation, by believed or alleged damages) arising from or via this website or its contents, including, but not limited to, errors, inaccuracies or errors, failures, delays, or interruptions in the operation or transmission of this website or its contents, communication line failures, any person, use of or this website or its content, any errors or omissions in the content, misuse of business losses, damages, lost profits, business interruption, loss of business information, or any other monetary or consequential loss or damage (even if User has notified the Company of the possibility of such loss or damage)."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "21.5 The Company will not be liable for any breach of these terms and conditions arising from circumstances beyond its reasonable control."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "21.6 The company reserves the right to withdraw the website and its content at any time, and reserves the right to pursue the user's deposit overrun without prior notice to the user."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("22 Indemnification")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "22.1 The user agrees to fully indemnify the company, its officers, directors, employees, consultants, agents, and suppliers from all claims, liabilities, damages, losses, costs, and expenses, including attorney's fees, arising from any breach of these terms and conditions, rules and regulations, or any other details of the user's account information, by the user, any other person's access to this website, or the use of the website."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("23 Applicable Law and Jurisdiction")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "23.1 The construction, validity and performance of this Agreement will be governed by the laws of the Philippines. However, this does not preclude any company from carrying any injunction or similar rescue action in courts of other jurisdictions. The English version of this Agreement will take precedence over any Company-issued version in any other language."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("24 Intellectual property rights")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "24.1 The content and services of the website are protected by national copyright and other intellectual property rights. The owner of the rights is 911 Entertainment City or other third-party licensors."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "24.2 Except to the extent required to use the Services to place bets or bets, they may not be published in any manner or form, or included on any other website or in any public or private electronic retrieval system or Services, including text, graphics, video, information, code, and/or software reproduce, store, modify, reproduce, repost, upload, publish, transmit or distribute any website content."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "24.3 Any use of the Site or Services or their content for commercial purposes is strictly prohibited."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("25 Responsible Gaming")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "25.1 Please contact the Account Team for any information regarding the equipment."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "25.2 The company will explain that the user uses reasonable methods to ensure that the user quits gambling. However, self-gambling requires the joint efforts of users and companies. While self-detoxifying, the user cannot attempt to open a new account, and the Company is not responsible for the User's continued gambling and/or attempting to use the Site and/or Services where the Company is unaware or unsure of circumstances beyond its reasonable control to self-detox gambling, including, but not limited to, opening a new account or over the phone instead of online or using a different name or address."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n(
                    "25.3 The company will strictly fulfill the above commitments."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("26 Contact Us")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("26.1 Users")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("27 Definitions")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("userAccount")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("ContentRefers")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("Privacylink")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("Rulesmeans")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("Softwaremeans")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("CompanyOur")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18n("WebsiteIs")}
                </Text>
                　
              </Box>
            </TabPanel>

            {/* 隱私政策內容 */}
            <TabPanel p={0}>
              <Box
                overflowY="auto"
                h="350px"
                w="100%"
                pr={2}
                css={{
                  // Firefox滾動條樣式
                  scrollbarWidth: "auto",
                  scrollbarColor: "#fdd26a rgba(0,0,0,0.3)",
                }}
                sx={{
                  ".chakra-menu__menuitem": {
                    paddingLeft: "15px",
                    paddingRight: "15px",
                  },
                  "&::-webkit-scrollbar": {
                    width: "15px",
                    display: "block",
                  },
                  "&::-webkit-scrollbar-track": {
                    bg: "rgba(0,0,0,0.3)",
                    borderRadius: "10px",
                    margin: "5px 0",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    bg: "linear-gradient(180deg, #fdd26a 0%, #b07f20 100%)",
                    borderRadius: "10px",
                    border: "3px solid rgba(0,0,0,0.2)",
                    boxShadow: "inset 0 0 5px rgba(255,255,255,0.3)", // 內光暈
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    bg: "linear-gradient(180deg, #ffdf8a 0%, #d19c2a 100%)",
                  },
                }}
              >
                <Text color="#e8c3ff" mb={4} fontSize="18px" fontWeight="600">
                  {i18nPrivacy("Privacy Policy")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "This is the privacy policy of owner and operator of 911win."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "This Privacy Policy sets out how 911win will manage your personal information which we collect as a result of your membership of 911win, your use of our websites located at https://911vip.tw and any pages or websites under the '911win' brand including any mobile phone or tablet applications that are owned and/or operated by us or whenever we otherwise deal with you."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "We are committed to ensuring that the personal information we collect about you is protected and is used, stored and disclosed in accordance with the Privacy Act and this Privacy Policy."
                  )}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("1. Website Use")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "In using the website, you agree to be bound by the terms of this Privacy Policy."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "911win may review the Privacy Policy periodically and reserves the right to change the Privacy Policy at any time at its discretion by posting such changes on the website."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "Changes will be effective immediately when posted on the website. Your continued use of the website following posting will constitute your acceptance of those changes."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "This Privacy Policy will not apply to websites which are linked to the website and over which 911win has no control."
                  )}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("2. Personal Information")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "The kinds of Personal Information that 911win may collect from you is:"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy("● Name")}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy("● Email Address")}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy("● Personally Submitted Preferences")}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy("● Date of Birth")}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy("● Country of Citizenship")}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy("● Physical Address")}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy("● Identification Number")}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy("● Government Issued Identification")}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy("● Location Data")}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy("● Device Information")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy("● IP Address")}
                </Text>

                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "The Company collects, or may collect, such information through methods including:"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● Data input during account registration processes"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy("● Communications with Customers")}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("3. Collection Purposes")}
                </Text>
                <Text color="white" fontSize="14px" mb={2}>
                  {i18nPrivacy(
                    "911win will collect your Personal Information only by lawful and fair means and not in an intrusive way to operate its business as a licensed online wagering bookmaker for the following purposes:"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● If you wish to subscribe to 911win's marketing communications."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● To process your application to become a Member of 911win or any managed subdomains."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● To provide and improve services to you as a Member."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● To identify you as a Member and authenticate your identity for security purposes and to comply with our legal obligations."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy("● To maintain your Member account.")}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● To upgrade and enhance your experience within the website or over the telephone, or to tailor or develop information, services or products to suit your needs which may include market research and conducting promotions."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● To tell you about our products or services that we think may be of interest to you by communicating with you via email, SMS or telephone."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● To create aggregate data about Members through demographic profiling, statistical analysis of the database to provide to potential and existing 911winholders, and to allow for more efficient operation of 911win's business."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● To respond to your questions, comments, or requests."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● To determine Members' liability to pay goods and services tax and other taxes where applicable."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● To comply with 911win's contractual, legal, and statutory obligations."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● For taking appropriate action if 911win has reason to suspect that unlawful activity or misconduct of a serious nature has been, is being or may be engaged in that relates to our functions and activities."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={1}>
                  {i18nPrivacy(
                    "● To establish, exercise or defend any legal claims."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy("● To manage job applications.")}
                </Text>

                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "If you do not provide 911win with the Personal Information we request, we may be unable to process your application to become a Member, provide you with our services or respond to your enquiry or complaint."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "By using 911win, becoming a Member or otherwise choosing to provide 911win with Personal Information you consent to 911win collecting, using, processing and potentially disclosing your Personal Information for the above purposes and on the bases described in this Privacy Policy."
                  )}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("4. Direct Marketing and Opting Out")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "From time to time we may use your Personal Information to inform you about our products or services or about promotional activities which 911win believes may be of interest or of benefit to you. We may do this via email, SMS, telephone or mail. If you no longer wish to receive marketing or promotional material from 911win at all or in any particular form, you may contact us at any time by may contact our customer support via Live Chat."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "with your request with which we will comply as soon as is practical."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "From time to time we may contact you in relation to the management and administration of your 911win account. These communications can be via any of the modes of contact recorded when registering as a Member. Such communication does not affect your opt-in or opt-out status for direct marketing communications."
                  )}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("5. Management of your Personal Information")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "911win will take all reasonable steps to ensure that the Personal Information which it collects, uses or discloses is correct and is stored in a secure environment which is accessed only by authorised persons. We store the personal information we receive as described in this Privacy Policy for as long as you use our Services or as necessary to fulfill the purpose(s) for which it was collected, provide our Services, resolve disputes, establish legal defenses, conduct audits, pursue legitimate business purposes, enforce our agreements, and comply with applicable laws."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "911win will destroy or permanently de-identify the Personal Information we hold when it is no longer required for any purpose permitted under the APPs including our legal or operational obligations."
                  )}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("6. Security of Personal Information")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "You acknowledge that no data transmission over the Internet is totally secure. Accordingly, 911win does not guarantee or warrant the security of any information which you transmit to it. Any information which you transmit to 911win is transmitted at your own risk. However, once 911win receives your transmission, 911win will take reasonable steps to protect your Personal Information from misuse, loss and unauthorized access, modification and disclosure including by using password protected systems and databases and Secure Socket Layer (SSL) technology. By using our Services or providing personal information to us, you agree that we may communicate with you electronically regarding security, privacy, and administrative issues relating to your use of the Services."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "911win's employees, agents and contractors are required to maintain the confidentiality of Members' Personal Information and trading behavior. Information posted on bulletin boards or communicated within a social media environment (for example, Facebook, Twitter, Chat Rooms) becomes public information. 911win cannot guarantee the security of this type of disclosed information."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "We take seriously the responsibility to exclude children from access to our services. We will not accept their information for the purposes of opening a wagering account. It is however, ultimately the responsibility of parents or guardians to monitor their children's Internet activities including where appropriate by using Internet screening software."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "Remember to always log out of your account when you have completed your time on the website. This is particularly important if you share a computer with another person. You are responsible for the security of and access to your own computer, mobile device or any other handset used to access the website."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "Ultimately, you are solely responsible for maintaining the secrecy of your username, password and any account information. Please be careful whenever using the Internet and our website."
                  )}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("7. Access to Personal Information")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    'You may access the Personal Information collected by 911win by following the "Settings" link on the website or by contacting us on may contact our customer support via Live Chat.'
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "We will give you access to your Personal Information in the manner requested if that is possible and within a reasonable period. If we refuse your request or cannot give you access in the manner you have requested, we will do what we can to meet your requirements by other means. We may not be required to give you access to your Personal Information in certain circumstances which are set out in the APPs including where it may have an unreasonable impact on another individual's privacy. If we refuse access for such reasons, we will advise you in writing of the refusal and our reasons and the complaint mechanisms available to you."
                  )}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("8. Delete Personal Data")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "You can request to have your personal data deleted if 911win no longer have a legal reason to continue to process or store it. Please note that this right is not guaranteed - in the sense that 911win do not have the ability to comply with your request if it is subject to a legal obligation to store your data. You can request the deletion of your personal data by sending an contact our customer support via Live Chat."
                  )}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("9. Contact Details")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "If you have any queries, requests for access or correction or complaints relating to the handling of your personal information, please contact us by the site customer support chat function."
                  )}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("10. International Data Transfers")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "All information processed by us may be transferred, processed, and stored anywhere in the world, including but not limited to other countries, which may have data protection laws that are different from the laws where you live."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "We endeavor to safeguard your information consistent with the requirements of applicable laws."
                  )}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("11. Legal Basis for Processing")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "For purposes of the EU General Data Protection Regulation, 911win's processing of your personal information is supported by the following lawful bases:"
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "Performance of a Contract: 911win needs to process your personal information to perform our contract with you or our Customer."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "Legitimate Interest: 911win processes your personal information to further our legitimate interests but only where our interests are not overridden by your interests or fundamental rights and freedoms."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "Consent: In some cases, 911win also relies on your consent to process your personal information."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "Compliance with Legal Obligations: 911win may process your personal information to comply with our legal obligations."
                  )}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("12. Supervisor Authority")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "If you are located in the European Economic Area, you have the right to lodge a complaint with a supervisory authority if you believe our processing of your personal information violates applicable law."
                  )}
                </Text>

                <Text
                  color="#e8c3ff"
                  mt={4}
                  mb={2}
                  fontSize="16px"
                  fontWeight="600"
                >
                  {i18nPrivacy("13. Updates to this Privacy Policy")}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "As noted, 911win may review, change and update this Privacy Policy from time to time reflect our current practices and obligations."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "We will publish our current Privacy Policy on our website at https://911vip.tw and the changes will take effect at the time of publishing."
                  )}
                </Text>
                <Text color="white" fontSize="14px" mb={3}>
                  {i18nPrivacy(
                    "You should review this privacy policy regularly and remain familiar with its terms."
                  )}
                </Text>
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </ChakraBox>
    </Flex>
  );
};

export default TermsModal;
